import React, { useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { createSignup } from "./apis/signup.services";
import Swal from 'sweetalert2';

const Signup = () => {
  const navigate = useNavigate();
  const [data, setData] = useState({
    username: "",
    hashedPwd: "",
    role: "admin",
  });
  const [loading, setLoading] = useState(false);

  const { username, hashedPwd, role } = data;

  const changeHandler = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    if (!username || !hashedPwd || !role) {
      Swal.fire({
        icon: "warning",
        title: "Missing fields",
        text: "Please fill in all the required fields.",
        confirmButtonColor: "#0b8a0b"
      });
      return;
    }

    setLoading(true);
    try {
      const res = await createSignup({ username, hashedPwd, role });
      console.log("Signup response:", res);
      
      Swal.fire({
        icon: "success",
        title: "Account Created",
        text: "Your account has been successfully created. Redirecting to Login...",
        showConfirmButton: false,
        timer: 2000
      });
      
      setTimeout(() => {
        setLoading(false);
        navigate("/");
      }, 2000);
    } catch (error) {
      setLoading(false);
      console.log("Signup Error:", error);
      Swal.fire({
        icon: "error",
        title: "Signup Failed",
        text: error.response?.data?.message || error.message || "An error occurred during sign up. Please try again.",
        confirmButtonColor: "#0b8a0b"
      });
    }
  };

  return (
    <section className="text-center" style={{ backgroundColor: "#f5f5f5", minHeight: "calc(100vh - 64px)" }}>
      {/* Spacer Header Accent */}
      <div
        className="p-5"
        style={{
          height: "135px",
          backgroundColor: "#f5f5f5"
        }}
      />
      {/* Form Card */}
      <div
        className="card mx-4 mx-md-5 shadow-5-strong"
        style={{
          marginTop: "-55px",
          background: "hsla(0, 0%, 100%, 0.8)",
          backdropFilter: "blur(30px)",
          borderRadius: "12px",
          border: "1px solid rgba(0,0,0,0.08)"
        }}
      >
        <div className="card-body py-4 px-md-5">
          <div className="row d-flex justify-content-center">
            <div className="col-12 col-md-8 col-lg-6">
              <h2 className="fw-bold mb-4" style={{ color: "#333", fontSize: "1.8rem" }}>Sign Up</h2>
              <form onSubmit={submitHandler}>
                
                {/* Username / Email input */}
                <div className="form-outline mb-4 text-start">
                  <label className="form-label" htmlFor="usernameInput" style={{ fontWeight: "600", fontSize: "13px", color: "#555" }}>
                    Email address
                  </label>
                  <input
                    required
                    type="email"
                    id="usernameInput"
                    onChange={changeHandler}
                    name="username"
                    value={username}
                    placeholder="Enter email address"
                    className="form-control"
                    style={{ padding: "10px 14px", fontSize: "14px" }}
                  />
                </div>

                {/* Password input */}
                <div className="form-outline mb-4 text-start">
                  <label className="form-label" htmlFor="passwordInput" style={{ fontWeight: "600", fontSize: "13px", color: "#555" }}>
                    Password
                  </label>
                  <input
                    required
                    type="password"
                    id="passwordInput"
                    onChange={changeHandler}
                    name="hashedPwd"
                    value={hashedPwd}
                    placeholder="Enter password"
                    className="form-control"
                    style={{ padding: "10px 14px", fontSize: "14px" }}
                  />
                </div>

                {/* Role select */}
                <div className="form-outline mb-4 text-start">
                  <label className="form-label" htmlFor="roleSelect" style={{ fontWeight: "600", fontSize: "13px", color: "#555" }}>
                    Role
                  </label>
                  <select
                    required
                    id="roleSelect"
                    onChange={changeHandler}
                    name="role"
                    value={role}
                    className="form-select"
                    style={{ padding: "10px 14px", fontSize: "14px" }}
                  >
                    <option value="admin">Admin</option>
                  </select>
                </div>

                {/* Submit button */}
                <button
                  type="submit"
                  disabled={loading}
                  style={{ 
                    padding: "10px 24px", 
                    backgroundColor: "#0b8a0b", 
                    color: "white", 
                    fontSize: "15px", 
                    fontWeight: "600",
                    width: "100%",
                    borderRadius: "6px",
                    border: "none",
                    boxShadow: "0 2px 6px rgba(11, 138, 11, 0.2)",
                    transition: "all 0.2s"
                  }}
                  className="btn btn-block mb-4"
                >
                  {loading ? (
                    <div className="spinner-border spinner-border-sm text-light" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  ) : (
                    "Sign Up"
                  )}
                </button>

                {/* Switch to Login */}
                <div className="text-center">
                  <p className="mb-0" style={{ fontSize: "14px", color: "#666" }}>
                    Already have an account?{" "}
                    <Link to="/" style={{ color: "#0b8a0b", fontWeight: "600", textDecoration: "none" }}>
                      Sign In
                    </Link>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Signup;
